import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_NAME, APP_VERSION } from './app-version';

interface VersionInfo {
  app?: string;
  version?: string;
  buildTime?: string;
  forceUpdate?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private http = inject(HttpClient);
  private intervalId: number | null = null;
  private checkInFlight = false;

  readonly currentVersion = APP_VERSION;
  readonly latestVersion = signal('');
  readonly forceUpdate = signal(false);
  readonly updateAvailable = signal(false);

  start() {
    this.check();
    if (this.intervalId === null) {
      this.intervalId = window.setInterval(() => this.check(), 5 * 60 * 1000);
    }
  }

  check() {
    if (this.checkInFlight) return;
    this.checkInFlight = true;
    this.http.get<VersionInfo>(`/version.json?_=${Date.now()}`).subscribe({
      next: info => {
        const latest = info?.version || '';
        const appMatches = !info?.app || info.app === APP_NAME;
        this.latestVersion.set(latest);
        this.forceUpdate.set(!!info?.forceUpdate);
        this.updateAvailable.set(!!latest && appMatches && latest !== APP_VERSION);
        this.checkInFlight = false;
      },
      error: () => {
        this.checkInFlight = false;
      }
    });
  }

  async reload() {
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        await registration?.update();
      } catch (err) {
        console.warn('Service worker update check failed', err);
      }
    }
    window.location.reload();
  }
}
